import React, { useEffect, useLayoutEffect, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import Spinner from '../../components/Loading/loadingSpinner/Spinner'
import { UseContextApp } from '../../Global/Context/appContext'
import { getInitial } from '../../helpers/getInitials'
import { actionTypes } from '../../Global/actions/types'
import ConsumoController from '../../controllers/ConsumoController'
import AuthController from '../../controllers/AuthController'
const PrivateRoute = () => {

  const navigate = useNavigate();
  const { state } = useLocation();

  const [{ user, consumoData }, dispatch] = UseContextApp()
  const { verifyDoc, signOut } = AuthController()
  const { consumo } = ConsumoController()
  const [loading, setLoading] = useState(false)
  const location = useLocation();

  const [responsive, setResponsive] = useState(false);
  const [showServicios, setShowServicios] = useState(false);
  const [showPagos, setShowPagos] = useState(false);
  const [showReportes, setShowReportes] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showFacturas, setShowFacturas] = useState(false);

  const openModalServicios = () => {

    setShowServicios(!showServicios);
    setResponsive(false);
    setShowPagos(false);
    setShowReportes(false);
    setShowProfile(false);
    setShowFacturas(false);
  };
  const openModalPagos = () => {

    setShowPagos(!showPagos);
    setResponsive(false);
    setShowReportes(false);
    setShowProfile(false);
    setShowServicios(false);
    setShowFacturas(false);
  };
  const openModalReportes = () => {

    setShowReportes(!showReportes);
    setShowServicios(false);
    setResponsive(false);
    setShowPagos(false);
    setShowProfile(false);
    setShowFacturas(false);
  };
  const openModalFacturas = () => {

    setShowFacturas(!showFacturas);
    setShowReportes(false);
    setShowServicios(false);
    setResponsive(false);
    setShowPagos(false);
    setShowProfile(false);
  };
  const openModalPerfil = () => {

    setShowProfile(!showProfile);
    setResponsive(false);
    setShowPagos(false);
    setShowReportes(false);
    setShowServicios(false);
    setShowFacturas(false);
  };
  const openModalResponsive = () => {

    setResponsive(!responsive);
    setShowProfile(false);
    setShowPagos(false);
    setShowReportes(false);
    setShowServicios(false);
    setShowFacturas(false);
  };

  const openModalResponsiveCorporativo = () => {

    setResponsive(!responsive);
    setShowProfile(false);
    setShowPagos(false);
    setShowReportes(false);
    setShowServicios(false);
    setShowFacturas(false);
  };

  const closeTodo = () => {

    setShowServicios(false);
    setResponsive(false);
    setShowPagos(false);
    setShowReportes(false);
    setShowProfile(false);
    setShowFacturas(false);
  }
  useLayoutEffect(() => {

    window.scrollTo(0, 0);
  }, [location.pathname]);

  const exit = async () => {

    setLoading(true);
    setTimeout(() => {
      localStorage.clear()
      navigate('/cuenta');
      setLoading(false)
    }, 1);

  }

  const noDataUser = async () => {

    if (!user.datos) {
      await verifyDoc({
        id: user.id,
        type: user.type,
        token: user.token,
      }).then((res) => {
        const initName = getInitial(res.nombreApellido);
        dispatch({
          type: actionTypes.USER_AUTH,
          payload: {
            ...user,
            datos: res,
            initial: initName
          },
        });
      });
    }
  };


  const getConsumo = async () => {
    const res = await consumo(user)
    if (res) {
      if (res.status === 99) { exit() }
      else { setLoading(false) }
    }
  }

  useEffect(() => {
    noDataUser();
  }, [user]);

  useEffect(() => {
  }, [consumoData])

  return localStorage.getItem('idToken') ? (
    //return validate === true ? (
    <>
      <div className='relative z-20 ɐzsʎuuǝʞ' onClick={closeTodo} >
        <Header exit={exit} openModalServicios={openModalServicios} openModalPagos={openModalPagos}
          openModalReportes={openModalReportes}
          openModalFacturas={openModalFacturas}
          openModalPerfil={openModalPerfil}
          openModalResponsive={openModalResponsive}
          openModalResponsiveCorporativo={openModalResponsiveCorporativo}
          responsive={responsive}
          showServicios={showServicios}
          showPagos={showPagos}
          showReportes={showReportes}
          showProfile={showProfile}
          showFacturas={showFacturas}
          loading={loading}
        />
        {
          loading ?
            (
              <>
                {
                  loading && (<>
                    <div className='h-screen z-[9999] top-0 bottom-0 right-0 left-0 w-full  flex  justify-center items-center'>
                      <Spinner title={'Espere...'} />
                    </div>
                  </>)
                }
              </>
            )
            :
            (
              <>
                <Outlet />

              </>
            )
        }
        <Footer />
      </div>
    </>

  ) : <Navigate to={'/cuenta'} />
}

export default PrivateRoute